import React, { useContext } from 'react';
import { Fab, Tooltip } from '@mui/material';
import { WhatsApp } from '@mui/icons-material';
import { AuthContext } from '../context/AuthContext';

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '15559953705';
const WHATSAPP_MESSAGE = 'Hi! I would like to know more about BookMyLibrary.';

function WhatsAppButton() {
  const { isAuthenticated } = useContext(AuthContext);

  if (isAuthenticated) return null;

  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

  return (
    <Tooltip title="Chat with us on WhatsApp" placement="left">
      <Fab
        component="a"
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'fixed',
          bottom: { xs: 80, md: 24 },
          right: { xs: 16, md: 24 },
          bgcolor: '#25D366',
          color: '#fff',
          zIndex: 1100,
          width: 56,
          height: 56,
          '&:hover': {
            bgcolor: '#128C7E',
          },
        }}
      >
        <WhatsApp sx={{ fontSize: 32 }} />
      </Fab>
    </Tooltip>
  );
}

export default WhatsAppButton;
